import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { HardwareService } from '../services/hardware.service';

export function deviceGuard(allowedDevice: 'mobile' | 'desktop', fallBackDestination: string): CanActivateFn {
  return () => {
    const mobile = inject(HardwareService).isMobile();
    return (allowedDevice === 'mobile' ? mobile : !mobile) ? true : inject(Router).parseUrl(fallBackDestination);
  };
}
